import localStorageService from '../../utils/local-storage-service'
import * as types from '../mutation-types'

const localStorageKey = {
  currentUser: 'currentUser',
  authData: 'authData'
}

const state = {
  get userInfo () {
    let userinfo = localStorageService.getItem(localStorageKey.currentUser)
    return userinfo || {userName: '', realName: '', roleName: '', shopIds: []}
  },
  set userInfo (v) {
    localStorageService.setItem(localStorageKey.currentUser, v)
  },
  get authData () {
    let authData = localStorageService.getItem(localStorageKey.authData)
    return authData || {
      token: '',
      refreshToken: '',
      isAuthed: false
    }
  },
  set authData (v) {
    localStorageService.setItem(localStorageKey.authData, v)
  }
}

const actions = {
  ClearUserInfo ({ commit }) {
    commit(types.UserClear)
  }
}

const mutations = {
  [types.UserTokenSet] (state, loginData) {
    state.authData = {
      token: loginData.access_token,
      refreshToken: loginData.refresh_token,
      isAuthed: true
    }
  },

  [types.UserInfoSet] (state, user) {
    state.userInfo = {
      userName: user.userName,
      realName: user.realName,
      roleName: user.roleName,
      shopIds: user.shopIds
    }
  },

  [types.UserClear] (state) {
    localStorageService.removeItem(localStorageKey.authData)
    localStorageService.removeItem(localStorageKey.currentUser)
    state.userInfo = { ...state.userInfo }
    state.authData = { ...state.authData }
  }
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/current-user.js